<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-occupancy-type-detail
      [occupancyType]="occupancyType"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedOccupancyType)="onSavedOccupancyType($event)"
      (canceledOccupancyType)="onCanceledOccupancyType()"
    ></app-occupancy-type-detail>
  </div>
</div>
